/* Nuvian · carrousel mobile à points (vitrine). Défilement natif + scroll-snap ;
   ce composant ne fait que synchroniser les points et la barre de progression. */
if (!customElements.get('nuvian-scroller')) {
  customElements.define(
    'nuvian-scroller',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.items = this.track ? [...this.track.querySelectorAll('[data-slide]')] : [];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.bar = this.querySelector('[data-progress]');
        if (!this.track || !this.items.length) return;
        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }

      go(i) {
        const item = this.items[i];
        if (!item) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const left = item.offsetLeft - this.items[0].offsetLeft;
        this.track.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
      }

      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        const ratio = max > 0 ? Math.min(1, Math.max(0, t.scrollLeft / max)) : 0;
        if (this.bar) this.bar.style.setProperty('--nv-progress', ratio.toFixed(3));
        const start = this.items[0].offsetLeft;
        let current = 0;
        this.items.forEach((item, i) => {
          if (item.offsetLeft - start <= t.scrollLeft + 8) current = i;
        });
        if (ratio > 0.98) current = this.items.length - 1;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === current ? 'true' : 'false'));
      }
    }
  );
}

/* État « Ajouté ✓ » (1,6 s) sur les boutons [data-nv-added] des cartes, de la vedette et du guide :
   écoute l'événement cartUpdate publié par product-form.js de Dawn (ajout réussi seulement). */
if (!window.nvAddedBound && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  window.nvAddedBound = true;
  subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
    if (!e || e.source !== 'product-form') return;
    document.querySelectorAll('[data-nv-added]').forEach((btn) => {
      const form = btn.closest('form');
      const id = form && form.querySelector('[name="id"]:checked, input[type="hidden"][name="id"]');
      if (!id || String(id.value) !== String(e.productVariantId)) return;
      const label = btn.querySelector('[data-nv-label]') || btn;
      if (!btn.nvLabel) btn.nvLabel = label.innerHTML;
      clearTimeout(btn.nvTimer);
      label.textContent = btn.dataset.nvAdded;
      btn.classList.add('is-added');
      btn.nvTimer = setTimeout(() => {
        label.innerHTML = btn.nvLabel;
        btn.classList.remove('is-added');
      }, 1600);
    });
  });
}

/* Carte produit : nom de la couleur choisie annoncé (aria-live) ; sans JS, la légende suffit. */
if (!window.nvColorBound) {
  window.nvColorBound = true;
  document.addEventListener('change', (e) => {
    const i = e.target;
    if (!i.classList || !i.classList.contains('nv-color__input')) return;
    const out = i.form && i.form.querySelector('[data-nv-color-name]');
    if (out) out.textContent = out.dataset.tpl.replace('__c__', i.dataset.name);
  });
}
